import Body from "../../../../../material/skeleton/Body";
import Footer from "../../../../../material/skeleton/Footer";
import {Button, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {CheckCircle} from "@mui/icons-material";
import {useEffect, useState} from "react";
import useQuotationItemRepository from "../../../../../repository/emergency/useQuotationItemRepository";
import useInterventionRepository from "../../../../../repository/emergency/useInterventionRepository";
import isNull from "../../../../../mixin/isNull";
import LoadingData from "../step/common/LoadingData";
import Typography from "@mui/material/Typography";
import QuotationItemOption from "../step/quotation/QuotationItemOption";
import Box from "@mui/material/Box";
import ShiftingAndMainWorkSupplement from "../step/quotation/ShiftingAndMainWorkSupplement";
import StandardizedItemSelector from "../step/quotation/StandardizedItemSelector";
import Modal from "../../../../../material/modal/Modal";
import ModalConfig from "../../../../../material/modal/ModalConfig";
import UpdateQuotationItem from "../step/quotation/UpdateQuotationItem";
import useHelper from "../../../../../use/useHelper";
import useQualityInspectionRepository from "../../../../../repository/emergency/useQualityInspectionRepository";

export default function ({qualityInspectionId, clientId, interventionId, orderId, onQuotationUpdated}) {
    const helper = useHelper();
    const qualityInspectionRepository = useQualityInspectionRepository();
    const interventionRepository = useInterventionRepository();
    const quotationItemRepository = useQuotationItemRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneById(interventionId).select();
    /** @type QuotationItem[] */
    const quotationItems = quotationItemRepository.findAllByQuotationId(intervention?.getQuotationId()).select();
    const [updateQuotationItem, setUpdateQuotationItem] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        interventionRepository.findOneById(interventionId).exec();
    }, []);

    useEffect(() => {
        if (isNull(intervention)) return;

        quotationItemRepository.findAllByQuotationId(intervention.getQuotationId()).exec();
    }, [JSON.stringify(intervention)]);

    const handleAdd = qi => {
        qi.quotation_id = intervention.getQuotationId();

        quotationItemRepository.create({
            quotation_item: qi
        });
    }

    const handleDelete = id => () => {
        quotationItemRepository.remove(id);
    }

    const handleUpdate = async qi => {
        if (qi.name != updateQuotationItem.getName()) {
            await quotationItemRepository.update(updateQuotationItem.getId(), "name", {
                quotation_item: {name: qi.name}
            });
        }

        if (qi.description != updateQuotationItem.getDescription()
            && (qi.description != "" && !isNull(updateQuotationItem.getDescription()))) {
            await quotationItemRepository.update(updateQuotationItem.getId(), "description", {
                quotation_item: {description: qi.description}
            });
        }

        if (qi.price != updateQuotationItem.getPrice()) {
            await quotationItemRepository.update(updateQuotationItem.getId(), "price", {
                quotation_item: {price: qi.price}
            });
        }

        if (qi.quantity != updateQuotationItem.getQuantity()) {
            await quotationItemRepository.update(updateQuotationItem.getId(), "quantity", {
                quotation_item: {quantity: qi.quantity}
            });
        }

        setUpdateQuotationItem(null);
    }

    const handleTerminate = async () => {
        await qualityInspectionRepository.validQuotation(qualityInspectionId);
        onQuotationUpdated();
    }

    const formatName = name => name.substring(0, 1).toUpperCase() + name.substring(1).toLowerCase();

    if (isNull(quotationItems)) return <LoadingData/>;

    return (
        <>
            <Body sx={{pt: 1, pb: 2, px: 1}}>
                <Table size={"small"}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Item</TableCell>
                            <TableCell>Qté</TableCell>
                            <TableCell>HT</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            quotationItems.map((qi, i) => (
                                <TableRow key={i}>
                                    <TableCell width={"65%"}>
                                        <Typography fontSize={"small"}>
                                            {formatName(qi.getName())}
                                        </Typography>
                                    </TableCell>
                                    <TableCell width={"15%"}>{helper.priceFormatter(qi.getQuantity())}</TableCell>
                                    <TableCell width={"15%"}>{helper.priceFormatter(qi.getPrice())}</TableCell>
                                    <TableCell width={"5%"}>
                                        <QuotationItemOption
                                            quotationItem={qi}
                                            onDelete={handleDelete(qi.getId())}
                                            onUpdate={() => setUpdateQuotationItem(qi)}
                                            disabled={!isNull(qi.getDefaultItemId())}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
                <Box mt={2}>
                    <ShiftingAndMainWorkSupplement
                        orderId={orderId}
                        onAdd={handleAdd}
                        currentQuotationItems={quotationItems.map(qi => {
                            return {
                                name: qi.getName()
                            }
                        })}
                    />
                </Box>
                <Box mt={2}>
                    <StandardizedItemSelector
                        key={JSON.stringify(quotationItems)}
                        orderId={orderId}
                        onSelect={handleAdd}
                        currentQuotationItems={quotationItems.map(qi => {
                            return {
                                standardized_item_id: qi.getStandardizedItemId()
                            }
                        })}
                    />
                </Box>

                {
                    !isNull(updateQuotationItem)
                        ? (
                            <Modal
                                modalConfig={
                                    new ModalConfig()
                                        .setOnClose(() => setUpdateQuotationItem(null))
                                        .setWidth("100%")
                                        .setHeight("80%")
                                        .setComponent(
                                            <UpdateQuotationItem
                                                quotationItem={{
                                                    name: updateQuotationItem.getName(),
                                                    description: updateQuotationItem.getDescription(),
                                                    price: updateQuotationItem.getPrice(),
                                                    quantity: updateQuotationItem.getQuantity(),
                                                    standardized_item_id: updateQuotationItem.getStandardizedItemId(),
                                                    default_item_id: updateQuotationItem.getDefaultItemId()
                                                }}
                                                onSubmit={handleUpdate}
                                            />
                                        )
                                }
                            />
                        )
                        : null
                }

            </Body>
            <Footer>
                <Button
                    sx={{height: "8.3dvh", borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={handleTerminate}
                    disabled={loading}
                    data-test="button-terminate-update-quotation"
                >
                    Modification terminée
                </Button>
            </Footer>
        </>
    )
}